// The one place a supported language is defined on the web app.
//
// Mirrors backend/src/utils/languages.js and
// mobile/lib/core/i18n/app_languages.dart. Adding a language means adding a row
// here and in those two files — no migration, no UI edit: the Identity picker
// renders straight off SUPPORTED_LANGUAGES.
//
// `code`        BCP-47, what we store and send to the API.
// `nativeLabel` what the picker shows — a speaker's own name for their language.
// `llmName`     the name to hand a model ("Reply in Malayalam"). Kept separate
//               from nativeLabel because prompts are written in English.

export const SUPPORTED_LANGUAGES = [
  { code: 'en', nativeLabel: 'English', englishLabel: 'English', llmName: 'English' },
  { code: 'hi', nativeLabel: 'हिन्दी', englishLabel: 'Hindi', llmName: 'Hindi' },
  { code: 'ml', nativeLabel: 'മലയാളം', englishLabel: 'Malayalam', llmName: 'Malayalam' },
];

export const DEFAULT_LANGUAGE_CODE = 'en';

const BY_CODE = new Map(SUPPORTED_LANGUAGES.map(l => [l.code, l]));

// Anything unrecognised — null, a code from a newer client, a display label
// sent instead of a code — falls back to English. The picker is a single
// <select>, so it must always have a value that matches an option.
export function normalizeLanguageCode(value) {
  if (typeof value !== 'string') return DEFAULT_LANGUAGE_CODE;
  const code = value.trim().toLowerCase().split(/[-_]/)[0];
  return BY_CODE.has(code) ? code : DEFAULT_LANGUAGE_CODE;
}

export function languageLabel(value) {
  return BY_CODE.get(normalizeLanguageCode(value)).nativeLabel;
}
